import React from 'react';
import history from 'app/routes/history';

import Button from 'app/components/general/Button';
import HeaderThin from 'app/components/layout/HeaderThin';
import PaymentCollectionList from '../PaymentCollectionList';
import PaymentSummary from './PaymentSummary';

interface IPaymentDetailProps {
  actions: any;
  isLoading: any;
  currentPayment: any;
  payments: any;
  teamMembers: any;
  teams: any;
  paymentCollections: any;
  paymentId: any;
  backendErrors: any;
  errors: any;
}
export default class PaymentDetail extends React.Component<
IPaymentDetailProps,
{}
> {
  static defaultProps: IPaymentDetailProps = {
    actions: undefined,
    backendErrors: undefined,
    isLoading: false,
    currentPayment: undefined,
    payments: {},
    teams: {},
    teamMembers: {},
    paymentCollections: {},
    paymentId: undefined,
    errors: {},
  };

  componentDidMount(): void {
    this.props.actions.getPayment(this.props.paymentId);
  }

  handleBackToTeam = () => {
    history.push('/manage-team');
  };

  handleBackToClub = () => {
    history.push('/manage-club');
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin title={this.props.currentPayment.description} divider />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-description">
              <p>
                Your payment request has been sent via SMS to the team members listed below. You can keep track of payments on this page.
              </p>
              <p>
                Once a team member has paid, you can expect to receive those funds in your nominated bank account within 1-3 business days. For more information,
                {' '}
                <a target="_blank" href="https://help.teammo.com.au/en/articles/3530012-how-long-does-it-take-to-receive-payments-from-team-members">read this article</a>
                .
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <PaymentSummary payment={this.props.currentPayment} />
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <PaymentCollectionList
              {...this.props}
              currentPayment={this.props.currentPayment}
              hasLoaded={
                this.props.paymentCollections.hasLoaded
              }
              paymentCollectionIds={
                this.props.currentPayment.paymentCollections
              }
              paymentCollectionsById={
                this.props.paymentCollections.paymentCollectionsById
              }
            />
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col btn-flex-group">
            <div className="btn-flex-container text-left">
              {this.props.currentPayment.paymentCategory
                === 'club-collection' && (
                <Button
                  className="btn-2"
                  onClick={this.handleBackToClub}
                >
                  Back to Club
                </Button>
              )}
              {this.props.currentPayment.paymentCategory
                === 'team-collection' && (
                <Button
                  className="btn-2"
                  onClick={this.handleBackToTeam}
                >
                  Back to Team
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
